// Author YuJiaBei
// Date 2022-02-25 17:19:57

import * as model from "@/model/em/inspection/InspectionStandardModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.InspectionStandard(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_INSPECTION_URL,
    })
    .buildStore()
